var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvaArrowBackOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.834 9.167H5.95l3.025-3.633a.834.834 0 0 0-1.283-1.067l-4.167 5a.992.992 0 0 0-.075.125c0 .042 0 .067-.058.108a.833.833 0 0 0-.058.3c0 .103.02.205.058.3 0 .042 0 .067.058.109a.984.984 0 0 0 .075.125l4.167 5a.834.834 0 0 0 1.283-1.067L5.95 10.834h9.884a.833.833 0 0 0 0-1.667z",
    fill: "#3E3E3E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaArrowBackOutline);
export default __webpack_public_path__ + "static/media/evaArrowBackOutline.2a846adc3d4eff4648ce8b1802c8727b.svg";
export { ForwardRef as ReactComponent };